export const CALL_SLOTS_STEP = 15;
